// extracted by mini-css-extract-plugin
module.exports = {"container":"why-choose_container__C5lkI","heading":"why-choose_heading__47Vka","title":"why-choose_title__rjVL5","cardsWrapper":"why-choose_cardsWrapper__MqhlU"};